// extracted by mini-css-extract-plugin
export default {"spinnerMark":"spinnerMark_JDvea","spinner":"spinner_IPeTe","spinner-fzua35":"spinner-fzua35_yOBWb"};